import namespace, * as types from './types';

const INITIAL_STATE = {
    cachedParams: undefined,
    overrides: undefined,
    params: {},
    visitorId: undefined,
};

const addTestParams = (state, action) => {
    const updatedParams = { ...state.params };

    action.payload.forEach(test => { updatedParams[test.name] = test; });

    return {
        ...state,
        params: updatedParams,
    };
};

const setOverrides = (state, action) => ({
    ...state,
    overrides: action.payload,
});

const setVisitorId = (state, action) => ({
    ...state,
    visitorId: action.payload,
});

const setCachedParams = (state, action) => ({
    ...state,
    cachedParams: action.payload,
});

const handlers = {
    [types.ADD_TEST_PARAMS]: addTestParams,
    [types.SET_OVERRIDES]: setOverrides,
    [types.SET_VISITOR_ID]: setVisitorId,
    [types.SET_CACHED_PARAMS]: setCachedParams,
};

function reducer(state = INITIAL_STATE, action = {}) {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
        const handler = handlers[action.type];

        return handler(state, action);
    }

    return state;
}

export {
    INITIAL_STATE,
};

const testData = {
    [namespace]: reducer,
};

export default testData;
